module.exports = __webpack_public_path__ + "media/images/favicon-a14d47648f3d877883b0fbc3fbb39e1a.ico";